"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.sharedService = exports.createSharedCollectionKey = exports.createSharedValueKey = exports.AppInitialized = exports.APP_EVENTS = exports.SharedValueContext = void 0;
const react_1 = require("react");
const rxjs_1 = require("rxjs");
const default_shared_store_1 = require("./default-shared-store");
const shared_value_resolving_1 = require("./shared-value-resolving");
exports.SharedValueContext = (0, react_1.createContext)(new default_shared_store_1.DefaultSharedStore());
exports.APP_EVENTS = createSharedCollectionKey('app_events', () => new rxjs_1.Subject());
exports.AppInitialized = 'app_initialized';
const createSharedValueKey = (id, defaultValue) => ({ id, defaultValue });
exports.createSharedValueKey = createSharedValueKey;
function createSharedCollectionKey(name, values) {
    if (isResolver(values))
        return createResolvedCollectionKey(name, values);
    return {
        id: name,
        defaultValue: new default_shared_store_1.DefaultSharedStore(),
        defaultKeyValue: values,
        collection: true
    };
}
exports.createSharedCollectionKey = createSharedCollectionKey;
function createResolvedCollectionKey(name, resolver) {
    const collection = new default_shared_store_1.DefaultSharedStore();
    const collectionResolver = new shared_value_resolving_1.SharedCollectionResolver(name, collection, resolver);
    return {
        id: name,
        defaultValue: collection,
        collection: true,
        resolver: collectionResolver
    };
}
function isResolver(values) {
    return !!values && typeof values === 'object';
}
// Just to simplify type capture so devs don't have to explicitly define their service contracts
function sharedService(factory) {
    return factory;
}
exports.sharedService = sharedService;
//# sourceMappingURL=shared-values.model.js.map